export default __webpack_public_path__ + "static/media/icono-abstracto-horizontal.7f7a54d8.svg";